import { FillType } from "./../../models/plotly/plotly-chart.model";
import { Component, OnInit, Inject, Output, EventEmitter } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Apollo } from "apollo-angular";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { updateOT } from "src/app/models/graphQL/mutations/updateOT.mutation";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialogRef } from "@angular/material/dialog";
import { deleteOT } from "src/app/models/graphQL/mutations/updateOT.mutation";
import { OrdenesServiceService } from "src/app/services/ordenes/ordenes-service.service";
import { LoginService } from "src/app/services/login/login.service";
import { ToastrService } from "ngx-toastr";
import { mongoMaestrosRequest } from "src/app/models/graphQL/mongoMaestros.request";

@Component({
  selector: "app-root",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
export class ModalComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  @Output() toastRequest = new EventEmitter();
  bandejasCantidad: number;
  bandejasTipo: string;
  bandejasFecha: any;
  addNewBandejaForm: FormGroup;
  genericFormGroup: FormGroup;
  genericTipo: any;
  genericValor: any;
  genericFecha: any;
  onClose: EventEmitter<boolean> = new EventEmitter();
  maestrosModels: any;
  selectedMaestro: any;
  piezasColumn: any;
  pesoSalida: any;
  piezasSalida: any;
  bandejasSalida: any;
  pesoBandeja: any;
  piezasBandeja: any;
  graphConfig: any = {};
  loadingPlotlyProceso: boolean;
  ot_status_message: string;
  isPrintEnabled: boolean = false;

  graph_x: any[];
  graph_y: any[];
  graph_data = {
    data: [],
    layout: {},
  };

  heatmap_anotations;
  heatmap_x: any[];
  heatmap_y: any[];
  heatmap_data = {
    data: [],
    layout: {},
  };

  bar_x: any[];
  bar_y: any[];
  bar_data = {
    data: [],
    layout: {},
  };

  pie_x: any[];
  pie_y: any[];
  pie_data = {
    data: [],
    layout: {},
  };

  wait: boolean = false;

  // PDF variables
  counter: number = 0;
  length: number = 0;
  pdf: jsPDF;
  headerPDFContent: any;
  headerContentHeight: number = 0;
  report_header = "report_header";
  report_divs_operation = [
    "report_consigna",
    "report_graph",
    "report_samples",
    "report_trays",
    "report_comments",
  ];
  report_divs_campaign = ["report_operations"];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private apollo: Apollo,
    public dialogRef: MatDialogRef<ModalComponent>,
    private ordenesService: OrdenesServiceService,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private toastrService: ToastrService,
    public dialog: MatDialog
  ) {}

  updateOrderStatus(data: any) {
    delete data.row["__typename"];
    delete data.row["bandejas"];
    delete data.row["comentarios"];
    delete data.row["muestras"];

    let inputData = Object.assign({}, data.row);
    delete inputData["_id"];
    delete inputData["modelo"]["__typename"];
    inputData["estado"] = data.new_status;
    switch (data.row.estado) {
      case "ot_not_started" || "ot_started":
        inputData["inicio"] = new Date().valueOf();
        inputData["fin"] = null;
        inputData["duracion"] = null;
        break;
      case "ot_started":
        inputData["fin"] = new Date().valueOf();
        inputData["duracion"] =
          (inputData["fin"] - inputData["inicio"]) / 60000;
        break;
    }
    this.apollo
      .mutate<any>({
        mutation: updateOT,
        variables: {
          _id: data.row._id,
          input: inputData,
        },
      })
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
      });
  }

  ngOnInit() {
    this.constructFormBuilders();
    this.constructGenericFormBuilder();
    this.findDataMaestros();
    if (this.data.option == 2 || this.data.option == 7) {
      if (!this.data.row.estado.includes("ot_not_started", "")) {
        try {
          this.ordenesService
            .findTipoDatoHornoForDisp(this.data.row.dispUUID)
            .subscribe(({ data, loading }) => {
              this.graphConfig = {
                dispositivos: [this.data.row.dispUUID],
                from: this.data.row.inicio,
                to: this.data.row.fin,
                limit: null,
                tipoDato: [],
                type: "scattergl",
                mode: "lines",
                layout: {
                  width: 900,
                  title: "",
                  height: 375,
                  margin: {
                    l: 45,
                    r: 5,
                    b: 55,
                    t: 15,
                  },
                  yaxis: {
                    rangemode: FillType.TOZERO,
                  },
                },
              };
              this.graphConfig.tipoDato = data.findTipoDatoHornoForDisp.map(
                (tdh) => tdh.uuid
              );
              this.graphConfig.tipoDatoName = data.findTipoDatoHornoForDisp.map(
                (tdh) => tdh.nombre
              );
              this.loadingPlotlyProceso = loading;
              this.isPrintEnabled = !loading;
            });
        } catch (e) {
          console.log("e: ", e);
        }
      } else if (this.data.row.estado.includes("ot_not_started", "")) {
        this.ot_status_message = "order_not_started_yet";
      }
    }
  }

  doPrintOperationReport(option) {
    if (option == 0) {
      // We need to open dialog with spinner
      this.dialog.open(ModalComponent, {
        width: "25%",
        id: "printOperationReportDialog",
        data: {
          title: "Generando Informe de Producción (Operación)...",
          wait: true,
          option: -1,
        },
      });
      // Initial configuration for Exporting PDF
      this.pdf = new jsPDF("l", "pt", "a4");
      this.length = this.report_divs_operation.length;
      this.counter = -1;

      // Call
      this.doGeneratePDF(0);
    } else {
      // We need to open dialog with spinner
      this.dialog.open(ModalComponent, {
        width: "25%",
        id: "printCampaignReportDialog",
        data: {
          title: "Generando Informe de Producción (Global)...",
          wait: true,
          option: -1,
        },
      });
      // Initial configuration for Exporting PDF
      this.pdf = new jsPDF("l", "pt", "a3");
      this.length = this.report_divs_campaign.length;
      this.counter = -1;

      // Call
      this.doGeneratePDF(1);
    }
  }

  doGeneratePDF(option) {
    let content;
    if (this.counter >= 0) {
      if (option == 0)
        if (option == 0)
          /*
            content = document.getElementById(this.report_header);
            content = content.after(document.getElementById(this.report_divs[this.counter]));
            */
          content = document.getElementById(
            this.report_divs_operation[this.counter]
          );
        else
          content = document.getElementById(
            this.report_divs_campaign[this.counter]
          );
    } else {
      content = document.getElementById(this.report_header);
    }
    const options = { background: "white", scale: 3 };
    html2canvas(content, options)
      .then((canvas) => {
        // Retrieve content from HTML
        var contentPDFFromHTML = canvas.toDataURL("image/png");

        // Adjust Variables
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;

        // PDF Adjustment
        const bufferX = 15;
        const bufferY = 15;
        const imgProps = (this.pdf as any).getImageProperties(
          contentPDFFromHTML
        );
        const pdfWidth = this.pdf.internal.pageSize.getWidth() - 2 * bufferX;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (this.counter < 0) {
          this.headerPDFContent = contentPDFFromHTML;
          this.headerContentHeight = pdfHeight;
        }

        // Add Content to PDF
        if (this.counter >= 0) {
          this.pdf.addImage(
            this.headerPDFContent,
            "PNG",
            bufferX,
            bufferY,
            pdfWidth,
            this.headerContentHeight,
            undefined,
            "FAST"
          );
          this.pdf.addImage(
            contentPDFFromHTML,
            "PNG",
            bufferX,
            bufferY + this.headerContentHeight,
            pdfWidth,
            pdfHeight,
            undefined,
            "FAST"
          );
        } else {
          //this.pdf.addImage(contentPDFFromHTML, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
        }

        // Increase counter
        this.counter++;

        // Control if new page needed, else generate the pdf
        if (this.counter < this.length) {
          if (this.counter > 0) this.pdf.addPage();
          return false;
        } else {
          return true;
        }
      })
      .then((result) => {
        if (result) {
          this.pdf.save(
            option == 0
              ? "report_operacion_" + this.data.row.orden + ".pdf"
              : "report_campana.pdf"
          );
          if (option == 0)
            this.dialog.getDialogById("printOperationReportDialog").close();
          else this.dialog.getDialogById("printCampaignReportDialog").close(); // Cerramos ventana modal de aviso de generación de informe
          this.dialog.closeAll(); // Cerramos ventana modal 1
        } else {
          this.doGeneratePDF(option);
        }
      });
  }

  doAddCampaign(type, id) {
    console.log("Do add campaign of type -> " + type);
  }

  doEditCampaign(type, id) {
    console.log("Do edit campaign of type -> " + type + " and ID -> " + id);
  }

  doRemoveCampaign(type, id, row) {
    this.apollo
      .mutate<any>({
        mutation: deleteOT,
        variables: {
          td: this.data.collection,
          _id: row._id,
        },
      })
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
      });
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d;
    }
  }

  onNoClick(): void {
    if (this.data.option == 6) this.computePiezasAndPeso();
    this.onClose.emit(true);
    this.dialogRef.close({ closed: true });
  }

  closeModal() {
    this.dialogRef.close();
  }

  constructFormBuilders() {
    if (this.data.id) {
      this.addNewBandejaForm = this.formBuilder.group({
        usuario: [
          this.loginService.currentUserValue.name,
          [Validators.required],
        ],
        usuarioUUID: [
          this.loginService.currentUserValue.uuid,
          [Validators.required],
        ],
        cantidad: [this.bandejasCantidad, [Validators.required]],
        fecha: [this.bandejasFecha, [Validators.required]],
        tipo: [this.bandejasTipo, [Validators.required]],
        idOF: [this.data.id._id, [Validators.required]],
      });
    }
  }

  constructGenericFormBuilder() {
    if (this.data.id) {
      this.genericFormGroup = this.formBuilder.group({
        usuario: [
          this.loginService.currentUserValue.name,
          [Validators.required],
        ],
        usuarioUUID: [
          this.loginService.currentUserValue.uuid,
          [Validators.required],
        ],
        valor: [this.genericValor, [Validators.required]],
        fecha: [this.genericFecha, [Validators.required]],
        tipo: [this.genericTipo, [Validators.required]],
        idOF: [this.data.id._id, [Validators.required]],
      });
    }
  }

  addBandejaToOF() {
    this.constructFormBuilders();
    this.ordenesService
      .insertBandejaInOF(
        this.data.id._id,
        this.addNewBandejaForm.get("usuario").value,
        this.addNewBandejaForm.get("usuarioUUID").value,
        this.addNewBandejaForm.get("cantidad").value,
        this.addNewBandejaForm.get("tipo").value
          ? this.addNewBandejaForm.get("tipo").value
          : "Entrada 1",
        new Date().valueOf()
      )
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
        this.onNoClick();
      });
  }

  computePiezasAndPeso() {
    this.ordenesService
      .getSingleOFData("ots", this.data.id._id)
      .subscribe(({ data }) => {
        this.bandejasSalida = data.retrieveSingleOrderData.bandejas
          .filter((b) => b.tipo.toLowerCase().includes("salida"))
          .reduce((accum, item) => accum + item.cantidad, 0);
        this.pesoSalida = this.pesoBandeja * this.bandejasSalida;
        this.piezasSalida = this.piezasBandeja * this.bandejasSalida;
        const inputData = {
          colada: this.data.id.colada,
          clave: this.data.id.clave,
          modelo: this.data.id.modelo,
          disp: this.data.id.hornoNombre,
          inicio: this.data.id.inicio,
          fin: this.data.id.fin,
          kgs: this.pesoSalida,
          piezas: this.piezasSalida,
          estado: this.data.id.estado,
          duracion: this.data.id.duracion,
        };
        delete inputData["modelo"]["__typename"];
        this.apollo
          .mutate<any>({
            mutation: updateOT,
            variables: {
              _id: this.data.id._id,
              input: inputData,
            },
          })
          .subscribe(({ data }) => {
            this.toastRequest.next(data);
          });
      });
  }

  findDataMaestros() {
    this.maestrosModels = [];
    this.apollo
      .query<any>({
        query: mongoMaestrosRequest,
        variables: {
          _id: "maestros",
        },
      })
      .subscribe(({ data, errors }) => {
        this.maestrosModels = data.findMaestros;
        if (this.data.id) {
          try {
            switch (this.data.id.disp.toLowerCase()) {
              case "horno 5":
                this.piezasColumn = "piezas_ban_h5";
                break;
              case "horno 6":
                this.piezasColumn = "piezas_ban_h6";
                break;
              default:
                this.piezasColumn = "piezas_ban_h6";
            }
          } catch (e) {
            this.piezasColumn = "piezas_ban_h6";
          }
          const objectToCompute = this.maestrosModels.filter(
            (maestro) => maestro["modelo"] == this.data.row.modelo.modelo
          )[0];
          if (objectToCompute) {
            this.pesoBandeja =
              parseInt(objectToCompute[this.piezasColumn]) *
              parseFloat(objectToCompute["peso_pieza_df"].replace(",", "."));
            this.piezasBandeja = parseInt(objectToCompute[this.piezasColumn]);
          } else {
            this.pesoBandeja = 0;
            this.piezasBandeja = 0;
          }
        }
      });
  }

  deleteArrayElementFromDocument(
    td: "ots" | "",
    _id: string,
    idx: number,
    type: string
  ) {
    const id = this.data.id._id;
    this.ordenesService
      .deleteArrayElementFromDocument(td, id, idx, type)
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
      });
    this.onNoClick();
  }

  addMuestraToOf() {
    this.constructGenericFormBuilder();
    this.ordenesService
      .insertMuestra(
        this.data.id._id,
        this.genericFormGroup.get("usuario").value,
        this.genericFormGroup.get("usuarioUUID").value,
        this.genericFormGroup.get("valor").value,
        "HB",
        Date.now()
      )
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
        this.onNoClick();
      });
  }

  insertComentario() {
    this.constructGenericFormBuilder();
    this.ordenesService
      .insertComentario(
        this.data.id._id,
        this.genericFormGroup.get("usuario").value,
        this.genericFormGroup.get("usuarioUUID").value,
        this.genericFormGroup.get("valor").value,
        this.genericFormGroup.get("tipo").value
          ? this.genericFormGroup.get("tipo").value
          : "comentario",
        Date.now()
      )
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
        this.onNoClick();
      });
  }

  //TODO Método previamente no implementado
  // openDialog(_, __) {}
}
